import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { Slot } from '@costar-ui/components';
import { cn } from '@costar-ui/cosmos';
import React__default, { useMemo } from 'react';

var Caption = function Caption(props) {
  var children = props.children,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'vertical' : _props$direction,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'lg' : _props$gap,
    alignItems = props.alignItems,
    justify = props.justify,
    responsive = props.responsive,
    className = props.className;
  var classNames = useMemo(function () {
    return cn('csg-tw-info-card-details overflow-hidden', responsive ? 'flex-[50%]' : 'flex-1', className);
  }, [className, responsive]);
  return children && /*#__PURE__*/React__default.createElement(Slot, _extends({
    as: "figcaption",
    direction: direction,
    className: classNames,
    gap: gap,
    fullWidth: true,
    alignItems: alignItems,
    justify: justify
  }, props), children);
};
Caption.displayName = 'Caption';
var Caption$1 = Caption;

export { Caption$1 as default };
//# sourceMappingURL=caption.esm.js.map
